// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15fjD","newExpiryDate":"styles_newExpiryDate__AFeWI","footer":"styles_footer__1wATA"};